import { Flex, Switch, Typography } from '@percent/lemonade'

import styles from './TaskAutosaveToggle.module.scss'

export type TaskAutosaveToggleProps = {
  enabled: boolean
  onToggle: (enabled: boolean) => void
  title: string
  description: string
}

export function TaskAutosaveToggle({
  enabled,
  onToggle,
  title,
  description,
}: Readonly<TaskAutosaveToggleProps>) {
  return (
    <Flex
      align="center"
      justify="space-between"
      gap={16}
      className={styles.wrapper}
      data-testid="auto-save-drafts-toggle"
    >
      <Flex direction="column" gap={2}>
        <Typography variant="default-medium">{title}</Typography>
        <Typography variant="small" $color="gray600">
          {description}
        </Typography>
      </Flex>
      <Switch
        checked={enabled}
        onChange={(event) => onToggle(event.currentTarget.checked)}
        aria-label={title}
        data-testid="auto-save-drafts-switch"
      />
    </Flex>
  )
}
